import { render, staticRenderFns } from "./get-self-managed-products.vue?vue&type=template&id=060d58e6&"
import script from "./get-self-managed-products.vue?vue&type=script&lang=js&"
export * from "./get-self-managed-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kolobox-admin/kolobox-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VApp } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VAlert,VApp,VDataTable,VFlex})
